import React from 'react'

const ChatIconOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3 7.5H7V6.5H3V7.5ZM3 6H9V5H3V6ZM3 4.5H9V3.5H3V4.5ZM1 11.5V2.5C1 2.225 1.09792 1.98958 1.29375 1.79375C1.48958 1.59792 1.725 1.5 2 1.5H10C10.275 1.5 10.5104 1.59792 10.7063 1.79375C10.9021 1.98958 11 2.225 11 2.5V8.5C11 8.775 10.9021 9.01042 10.7063 9.20625C10.5104 9.40208 10.275 9.5 10 9.5H3L1 11.5ZM2.575 8.5H10V2.5H2V9.0625L2.575 8.5Z'
      fill='currentColor'
    />
  </svg>
)

export default ChatIconOutline
